import { render, staticRenderFns } from "./BackerCenterPaymentsSection.vue?vue&type=template&id=e7a9a800"
import script from "./BackerCenterPaymentsSection.vue?vue&type=script&lang=js"
export * from "./BackerCenterPaymentsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports